"use client";

import React, { useRef } from "react";
import { Provider } from "react-redux";
import Main from "@/redux/app/main";
import { Props } from "@/redux/interfaces/page";
import getStore, { AppStore } from "@/redux/store";
import ApolloFab from "@/components/ApolloFab";

const App: React.FC<Props> = ({ children, pageProps, serverPathname, xAuthToken, xMobileNumber }) => {
  const store = useRef<AppStore>();
  if (!store.current) store.current = getStore();

  return (
    <>
      <Provider store={store.current}>
        {/* <ErrorBoundary> */}
        <Main
          serverPathname={serverPathname}
          pageProps={pageProps}
          xAuthToken={xAuthToken}
          xMobileNumber={xMobileNumber}
        >
          {children}
        </Main>
        {/* </ErrorBoundary> */}
        <ApolloFab fabData={pageProps?.fabData} isMobile={pageProps?.ua?.isMobile} />
      </Provider>
    </>
  );
};

export default App;
